export default __webpack_public_path__ + "static/media/apostar_icons_eingabe_3_gewinnverlust.aaed4395.svg";